import React from 'react';

import {MediaQuery, Skeleton} from '@optimaxdev/design-system';

import {useMediaQuery} from 'react-responsive';

import s from './paymentCreditCartSkeleton.scss';

/**
 * PaymentCreditCartSkeleton
 */
export const PaymentCreditCartSkeleton = () => {
    const isSmallScreen = useMediaQuery(MediaQuery.sm);
    return (
        <div className={s.wrapper}>
            <div className={s.wrapperCreditCart}>
                <Skeleton className={s.cardNumber} height="56px" radius="8px" />
                <Skeleton className={s.expiration} height="56px" radius="8px" />
                <Skeleton className={s.cvv} height="56px" radius="8px" />
            </div>

            <Skeleton className={s.savedCard} height="24px" radius="100px" width="350px" />

            <div className={s.buttonWrapper}>
                <Skeleton className={s.button} height="48px" radius="8px" width="334px" />
                {isSmallScreen ? (
                    <div className={s.bottomSection}>
                        <Skeleton height="20px" radius="100px" width="264px" />
                        <Skeleton height="20px" radius="100px" width="310px" />
                        <Skeleton height="20px" radius="100px" width="404px" />
                    </div>
                ) : (
                    <>
                        <Skeleton height="20px" radius="100px" width="476px" />
                        <Skeleton height="20px" radius="100px" width="331px" />
                    </>
                )}
            </div>
        </div>
    );
};
